"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnKeyDown = void 0;
const react_1 = require("react");
function useOnKeyDown(callback, keys) {
    (0, react_1.useEffect)(() => {
        window.addEventListener("keydown", handler);
        return () => {
            window.removeEventListener("keydown", handler);
        };
    }, [handler]);
    function handler(event) {
        const keyboardEvent = event;
        if (typeof keys === "string" && keyboardEvent.key === keys) {
            callback(event);
            return;
        }
        if (Array.isArray(keys) &&
            keys.some(item => {
                if (typeof item === "string")
                    return keyboardEvent.key === item;
                return Object.keys(item).every(index => keyboardEvent[index] === item[index]);
            })) {
            callback(event);
            return;
        }
        if (!Array.isArray(keys) &&
            typeof keys !== "string" &&
            Object.keys(keys).every(index => keyboardEvent[index] === keys[index])) {
            callback(event);
            return;
        }
    }
}
exports.useOnKeyDown = useOnKeyDown;
